module.exports = __webpack_public_path__ + "img/POPULAR_Career_v6.9b7dc4f2.jpg";